import React, { useEffect } from 'react'
import Header from 'components/Header'
import Section from './components/Section'
import Footer from 'components/Footer'

function Lawyer() {
  useEffect(() => {
    document.title = 'Macias e Cruz - Advogados'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main>
      <Header />
      <Section />
      <Footer />
    </main>
  )
}

export default Lawyer
